import * as React from "react"
import type { SVGProps } from "react"
const SvgSegment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4.5 20q-.82 0-1.41-.59A2 2 0 0 1 2.5 18V6q0-.82.59-1.41A2 2 0 0 1 4.5 4h5.18a2 2 0 0 1 1.4.57L12.5 6h8q.83 0 1.41.59.6.59.59 1.41v10q0 .83-.59 1.41a2 2 0 0 1-1.41.59zm0-2h16V8h-8.82l-2-2H4.5zm7-1h8v-.55q0-1.13-1.1-1.79T15.5 14c-1.8 0-2.17.22-2.9.66q-1.1.66-1.1 1.79zm4-4q.83 0 1.41-.59.6-.58.59-1.41 0-.82-.59-1.41A2 2 0 0 0 15.5 9q-.83 0-1.41.59A2 2 0 0 0 13.5 11q0 .83.59 1.41.58.6 1.41.59" />
  </svg>
)
export default SvgSegment
